import { render, staticRenderFns } from "./ReferralLanding.vue?vue&type=template&id=2cc3a79a&scoped=true"
import script from "./ReferralLanding.vue?vue&type=script&lang=js"
export * from "./ReferralLanding.vue?vue&type=script&lang=js"
import style0 from "./ReferralLanding.vue?vue&type=style&index=0&id=2cc3a79a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc3a79a",
  null
  
)

export default component.exports